import { render, staticRenderFns } from "./DimmedArea.vue?vue&type=template&id=5f49de72&scoped=true&"
import script from "./DimmedArea.vue?vue&type=script&lang=ts&"
export * from "./DimmedArea.vue?vue&type=script&lang=ts&"
import style0 from "./DimmedArea.vue?vue&type=style&index=0&id=5f49de72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f49de72",
  null
  
)

export default component.exports